<template>
  <div v-bind:class="{'inline-block': inline}">
    <label
      :for="sid"
      class="radio radio-inline"
      v-bind:class="{'state-disabled':disabled, 'state-error': model.$error}"
    >
      <input
        type="radio"
        :checked="checked"
        :disabled="disabled"
        :id="sid"
        ref="input"
        :value="value"
        @click="onClick($event)"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      />
      <i></i>
      <slot>{{getTitle}}</slot>
      <w-description
        :model="model"
        :value="description.value"
        :tooltip="description.tooltip"
        :htmlContent="description.htmlContent"
      >
        <slot name="description" />
      </w-description>
      <w-error :model="model" v-if="showError"></w-error>
    </label>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';

export default {
  // props: ['model', 'value'],
  name: 'w-radio',
  props: {
    inline: Boolean,
    showError: {
      type: Boolean,
      default: true
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false
      }),
      required: false
    }
  },
  components: {
    WError
  },
  mixins: [modelMixin],
  data() {
    return {
      sid: 'rad.' + this.value + '.' + Math.random() * 1000000
    };
  },
  computed: {
    checked() {
      // if (this.$options.hasFocus) {
      //   return this.model.$model === this.value;
      // }
      if (this.model.$model instanceof Array) {
        return this.model.$model.includes(this.value);
      } else {
        return this.model.$model === this.value;
      }
    }
  },
  // mounted() {},
  methods: {
    onClick(evt) {
      this.$options.hasFocus = true;
      this.$emit('click');
      this.model.$hasFocus = true;
    },
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
      this.model.$hasFocus = true;
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
      this.model.$hasFocus = false;
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      // console.log('radio input', evt.target.checked);
      if (evt.target.checked) {
        if (this.model.$model instanceof Array) {
          // console.log('set data', [this.value]);
          this.model.$setData([this.value], true, true);
          /*
          const ii = this.model.$model.indexOf(this.value);
          if (ii > -1) {
            this.model.$model.splice(0);
          }

          this.model.$model.push(this.value);
          */
        } else {
          this.model.$model = this.value;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>
<style scoped>
.radio-inline,
.inline-block {
  display: inline-block !important;
}
</style>
